import { BasicModal } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { ActivationOption } from "app/pages/activation/components/GAWidget/ActivationModal/ActivationOption";
import { modalStyles } from "app/pages/activation/components/GAWidget/ActivationModal/config";
import { activationModalDataAutomation } from "app/pages/activation/components/GAWidget/dataAutomationKeys";
import { ActivationModalTexts } from "app/pages/activation/components/GAWidget/texts";

import { GATriggerWithPropertyMapping, type GATriggerWithPropertyMappingSchema } from "../../ga-connect";

import * as SC from "./styles";

type ActivationModalSchema = Pick<GATriggerWithPropertyMappingSchema, "activationId" | "hasGaMapping"> & {
    isOpen: boolean;
    onClose: () => void;
    onGAConnect: () => void;
    onSWConnect: () => void;
};

export const ActivationModal = ({
    activationId,
    hasGaMapping,
    isOpen,
    onClose,
    onGAConnect,
    onSWConnect,
}: ActivationModalSchema) => {
    return (
        <GATriggerWithPropertyMapping
            activationId={activationId}
            hasGaMapping={hasGaMapping}
            onOpen={onGAConnect}
        >
            {({ isLoading, open }) => (
                <BasicModal
                    isOpen={isOpen}
                    onRequestClose={onClose}
                    closeIconConfig={isLoading ? { show: false } : undefined}
                    customStyles={modalStyles}
                    dataAutomation={activationModalDataAutomation.modalContainer}
                >
                    <SC.Header data-automation={activationModalDataAutomation.header}>
                        {translate(ActivationModalTexts.header)}
                    </SC.Header>

                    <SC.Body>
                        <SC.SubTitle>{translate(ActivationModalTexts.subtitle)}</SC.SubTitle>

                        <ActivationOption
                            onClick={open}
                            title={ActivationModalTexts.GATitle}
                            description={translate(ActivationModalTexts.GADescription)}
                            iconName="ga-icon"
                            isLoading={isLoading}
                        />

                        <ActivationOption
                            onClick={onSWConnect}
                            title={ActivationModalTexts.SWTitle}
                            description={translate(ActivationModalTexts.SWDescription)}
                            iconName="similar-icon"
                            isDisabled={isLoading}
                        />
                    </SC.Body>
                </BasicModal>
            )}
        </GATriggerWithPropertyMapping>
    );
};

ActivationModal.displayName = "ActivationModal";
